import { makeStyles } from 'tss-react/mui';

const useStylesTableHead: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableHeadHeader: {
    '& > tr > th': {
      minWidth: 100,
      maxWidth: 1000,
      whiteSpace: 'normal',
      padding: '5px 10px',
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      zIndex: 15,
      '&:hover': {
        cursor: 'default',
      },
      '&:first-of-type': {
        paddingLeft: 16,
      },
      '&:last-of-type': {
        paddingRight: 16,
      },
      '& > span': {
        color: theme.palette.common.white,
        '&:hover, &:focus': {
          color: `${theme.palette.common.white} !important`,
        },
      },
    },
  },
  tableHeadSubHeader: {
    '& > tr > th': {
      whiteSpace: 'normal',
      minWidth: 100,
      maxWidth: 1000,
      padding: '5px 10px',
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.dark,
      '&:hover': {
        cursor: 'default',
      },
      '&:first-of-type': {
        paddingLeft: 16,
      },
      '&:last-of-type': {
        paddingRight: 16,
      },
    },
  },
  tableHeadFixedCellsSize: {
    '& > tr > th': {
      whiteSpace: 'nowrap',
      minWidth: 200,
    },
  },
  tableHeadFixedCellsSizeCompressed: {
    '& > tr > th': {
      whiteSpace: 'nowrap',
      minWidth: 120,
    },
  },
  tableHeadNoPadding: {
    '& > tr > th': {
      padding: 0,
    },
  },
}));

export default useStylesTableHead;
